import * as React from 'react';
import { Row, Col } from 'react-bootstrap';
import { Field } from 'redux-form';

import { NotificationPriority } from '@acceligentllc/shared/enums/notificationPriority';

import { MAX_EMPLOYEE_NOTIFICATION_MESSAGE_LENGTH } from 'ab-common/constants/value';

import { SegmentLabel } from '@acceligentllc/storybook';

import Input from 'af-fields/Input';
import Textarea from 'af-fields/Textarea';

interface OwnProps {
	notificationPriority?: NotificationPriority;
}

type Props = OwnProps;

class NotifyUsersFields extends React.PureComponent<Props> {
	render() {
		const { notificationPriority } = this.props;
		const onlySms = notificationPriority && notificationPriority === NotificationPriority.SMS_ONLY;
		const sendBothOrOneThenOther = notificationPriority
			&& notificationPriority !== NotificationPriority.SMS_ONLY
			&& notificationPriority !== NotificationPriority.EMAIL_ONLY;
		const tooltip = sendBothOrOneThenOther ? 'This field is used only in email.' : null;

		return (
			<>
				{!onlySms &&
					<>
						<Row>
							<Col className="m-b-m" sm={24}>
								<SegmentLabel
									label="Message"
									tooltip="Compose the notification message, including subject, heading, body text, and footer, that will be sent to the selected users."
								/>
							</Col>
						</Row>
						<Row>
							<Col md={12}>
								<Field
									component={Input}
									isRequired={true}
									label="Subject"
									name="subject"
									tooltipMessage={tooltip}
								/>
							</Col>
							<Col md={12}>
								<Field
									component={Input}
									label="Heading"
									name="heading"
									tooltipMessage={tooltip}
								/>
							</Col>
						</Row>
					</>
				}
				<Row>
					<Col md={24}>
						<Field
							component={Textarea}
							controlCursor={true}
							label="Message *"
							maxCharacters={MAX_EMPLOYEE_NOTIFICATION_MESSAGE_LENGTH}
							name="message"
							rows={5}
							showMaxCaractersLabel={true}
						/>
					</Col>
				</Row>
				{!onlySms &&
					<Row>
						<Col md={24}>
							<Field
								component={Textarea}
								controlCursor={true}
								label="Footer"
								maxCharacters={MAX_EMPLOYEE_NOTIFICATION_MESSAGE_LENGTH}
								name="footer"
								rows={5}
								showMaxCaractersLabel={true}
								tooltipMessage={tooltip}
							/>
						</Col>
					</Row>
				}
			</>
		);
	}
}

export default NotifyUsersFields;
